var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{class:("m-" + _vm.margin),attrs:{"src":_vm.env.APPS + 'assets/img/ajax-loader.gif'}})])}
var staticRenderFns = []

export { render, staticRenderFns }